import 'core-js/proposals/iterator-helpers';
import 'zone.js';
import '@angular/localize/init';